import React, { useEffect } from 'react';
import { Breadcrumbs, Grid, SpaceWrapper, StickyNavigation } from '../../ui-toolkit/components';
import { UserProfileContainer } from 'components/userProfile/UserProfileContainer';
import { useParams } from 'react-router-dom';
import { useKeyToSelect } from 'store/createKeyedDataAsyncSlice';
import { RootStore } from 'store/types';
import { EditLenderContainer } from 'components/lenders/EditLenderContainer';
import { useAppDispatch } from 'store/store';
import { getLenderInfoAction } from 'store/order/clientLenderContacts/slices';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';

export const LenderCompanyEditPage: React.FC = () => {
  const { lenderId } = useParams<{ lenderId: string }>();
  const { data, fetchStatus } = useKeyToSelect(lenderId, (store: RootStore) => store.clientLenderContacts.lenderInfo);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getLenderInfoAction(lenderId));
  }, [dispatch, lenderId]);

  return (
    <>
      <StickyNavigation activeMain={'Lenders'} profile={<UserProfileContainer />} />
      <SpaceWrapper topSpace={'none'}>
        <Grid>
          <Breadcrumbs
            homeLink={ClientUrlFactory().urlFor.adminOrders()}
            links={[
              {
                to: ClientUrlFactory().urlFor.lendersIndex(),
                text: 'Lenders',
              },
              {
                to: ClientUrlFactory().urlFor.lenderCompany(lenderId),
                text: data?.lender.name || lenderId,
              },
            ]}
          />
          {fetchStatus.success && data && <EditLenderContainer lender={data} />}
        </Grid>
      </SpaceWrapper>
    </>
  );
};
